import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import InputAdornment from "@mui/material/InputAdornment";
import { 
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon 
} from '@mui/icons-material';
import { TextInput, Services, Modal, Theme } from '@simplybenefits/sb-ui-library';

import { changePassword } from '../../actions/users.js';
import { getUserType } from '../../services/session.js';
import * as notifier from '../../actions/notifier.js';

class ChangePassword extends PureComponent {
    state = {
        password: '',
        confirmPassword: '',
        visibility: false
    };

    _toggleVisibility = () => {
        this.setState({
            visibility: !this.state.visibility
        });
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type])
        });
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value.trim()
        });
    };

    _confirm = async () => {
        const passwordError = await Services.validateInput('password', this.state.password);
        const confirmPasswordError = await Services.validateInput('confirmPassword', this.state.confirmPassword);

        this.setState({
            passwordError,
            confirmPasswordError
        });

        if (passwordError || confirmPasswordError) {
            return false;
        }

        if (this.state.password !== this.state.confirmPassword) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Your passwords do not match.'
            }));

            this.setState({
                passwordError: 'Your passwords do not match.',
                confirmPasswordError: 'Your passwords do not match.'
            });

            return false;
        }

        const userType = Number(getUserType()) === 1;
        let success = null;

        success = await this.props.dispatch(changePassword(userType, this.state.password));

        if (success) {
            this.props.hideModal();

            this.setState({
                passwordError: false,
                confirmPasswordError: false
            });
        }

        return null;
    };

    render() {
        const { hideModal } = this.props;

        return (
            <Modal
                open={true}
                onClose={hideModal}
                title="Change Password"
                primaryButton={{
                    onClick: this._confirm
                }}
                loader={this.props.loader}
            >
                <TextInput
                    label="Password"
                    value={this.state.password}
                    inputProps={{
                        endAdornment: (
                            <InputAdornment position="end" sx={{ marginRight: 1 }}>
                                {
                                    this.state.visibility ?
                                        <VisibilityIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                            onClick={this._toggleVisibility}
                                        />
                                        :
                                        <VisibilityOffIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                            onClick={this._toggleVisibility}
                                        />
                                }
                            </InputAdornment>
                        )
                    }}
                    onBlur={() => this._onBlur('password')}
                    onChange={(value) => this._handleInputChange('password', value)}
                    error={Boolean(this.state.passwordError)}
                    helperText={this.state.passwordError}
                    secure={!this.state.visibility}
                    fullWidth
                    autofocus
                />

                <TextInput
                    label="Confirm Password"
                    value={this.state.confirmPassword}
                    inputProps={{
                        endAdornment: (
                            <InputAdornment position="end" sx={{ marginRight: 1 }}>
                                {
                                    this.state.visibility ?
                                        <VisibilityIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                            onClick={this._toggleVisibility}
                                        />
                                        :
                                        <VisibilityOffIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey }}
                                            onClick={this._toggleVisibility}
                                        />
                                }
                            </InputAdornment>
                        )
                    }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                    onBlur={() => this._onBlur('confirmPassword')}
                    onChange={(value) => this._handleInputChange('confirmPassword', value)}
                    error={Boolean(this.state.confirmPasswordError)}
                    helperText={this.state.confirmPasswordError}
                    secure={!this.state.visibility}
                    fullWidth
                />

            </Modal>
        );
    }
}

export default connect()(ChangePassword);